<template>
    <ul class="Menu__warp_nstl" v-if="active != MENU_ACTIVE.DATA_INDEX ">
        <!--数据建模-->
        <template v-if="header == HEADER_ACTIVE.DATA_MANAGER">
           <!-- v-show="functionInfoList.some(item => item == 'B01A01')" -->
            <router-link to="/data_model_edit">
                <li :class="{ active: active == MENU_ACTIVE.DATA_MODELING_DESIGN }">
                    <img src="../assets/menu/moxingsheji.svg" />
                    <!--数据建模-->
                    <span style="text-align: center;">数据模型<br>设计</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'B01A02')" -->
            <router-link to="/data_model" >
                <li :class="{ active: active == MENU_ACTIVE.DATA_MODELING }" >
                    <img src="../assets/menu/shujujianmo.svg" />
                    <!--数据建模-->
                    <span style="text-align: center;">数据模型<br>管理</span>
                </li>
            </router-link>
             <!-- v-show="functionInfoList.some(item => item == 'B01A03')" -->
            <!-- <router-link to="/knowledge_tabs_list" >
                <li :class="{ active: active == MENU_ACTIVE.ZHISHI_BIAOQIAN }">
                    <img src="../assets/menu/biaoqianguanli.svg" /> -->
                    <!--数据建模-->
                    <!-- <span style="text-align: center;">知识标签<br>管理</span>
                </li>
            </router-link> -->
            <!-- v-show="functionInfoList.some(item => item == 'B01A04')" -->
           
            <!--<router-link to="/data_import_List">
                <li :class="{ active: active == MENU_ACTIVE.DATA_IMPORT_LIST }">
                    <img src="/static/menu/shujujiazai.svg" />
                    数据加载
                </li>
            </router-link>
            <router-link to="/data_stat">
                <li :class="{ active: active == MENU_ACTIVE.DATA_STAT }">
                    <img src="/static/menu/shujutongji.svg" />
                    数据统计
                </li>
            </router-link>-->
        </template>
        <!-- 共享交换 -->
        <template v-if="header == HEADER_ACTIVE.DATA_WORK">
          <!-- v-show="functionInfoList.some(item => item == 'C01A01')" -->
            <router-link to="/data_import_List" >
                <li :class="{ active: active == MENU_ACTIVE.DATA_IMPORT_LIST }" >
                    <img src="../assets/menu/xinxizhiyuandaoru.svg" />
                    <span style="text-align: center;">信息资源<br>导入</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'C01A02')" -->
            <router-link to="/data_view_resource" >
                <li :class="{ active: active == MENU_ACTIVE.Data_View_Resource }"  >
                    <img src="../assets/menu/xinxiziyuandaochu.svg" />
                    <span style="text-align: center;">信息资源<br>导出</span>
                </li>
            </router-link>


            <!--<router-link to="/data_maintain">
                <li :class="{ active: active == MENU_ACTIVE.DATA_MAINTAIN }">
                    <img src="/static/menu/datamaintain.svg" />
                    <span style="text-align: center;">基础数据<br>维护</span>
                </li>
            </router-link>
            <router-link to="/data_calculate">
                <li :class="{ active: active == MENU_ACTIVE.DATA_CALCULATE }">
                    <img src="/static/menu/datacalculate.svg" />
                    <span style="text-align: center;">加工数据<br>计算</span>
                </li>
            </router-link>
            <router-link to="/processing_task">
                <li :class="{ active: active == MENU_ACTIVE.PROCESSOMG_TASK }">
                    <img src="/static/menu/processing.svg" />
                    <span style="text-align: center;">加工任务<br>管理</span>
                </li>
            </router-link>
            <router-link to="/processing_data">
                <li :class="{ active: active == MENU_ACTIVE.PROCESSOMG_DATA }">
                    <img src="/static/menu/processingdata.svg" />
                    <span style="text-align: center;">加工数据<br>审计</span>
                </li>
            </router-link>-->
        </template>
        <!--首页-->
        <template v-if="header == HEADER_ACTIVE.INDEX">
            <!--<router-link to="/data_index">
                <li :class="{ active: active == MENU_ACTIVE.DATA_INDEX }">
                    <img src="../assets/menu/shujuquanjing.svg" />
                    数据全景
                </li>
            </router-link>
            <router-link to="/data_view_resource">
                <li :class="{ active: active == MENU_ACTIVE.Data_View_Resource }">
                    <img src="../assets/menu/shujuziyuan.svg" />
                    数据资源
                </li>
            </router-link>
            <router-link to="/data_view_model">
                <li :class="{ active: active == MENU_ACTIVE.Data_View_Model }">
                    <img src="../assets/menu/shujumoxing.svg" />
                    数据模型
                </li>
            </router-link>-->
        </template>
        <!-- 数据加工 -->
        <template v-if="header == HEADER_ACTIVE.DATA_USE">
          <!-- v-show="functionInfoList.some(item => item == 'D01A01')" -->
            <router-link to="/data_maintain" >
                <li :class="{ active: active == MENU_ACTIVE.DATA_MAINTAIN }" >
                    <img src="/static/menu/datamaintain.svg" />
                    <span style="text-align: center;">数据编辑<br>加工</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'D01A02')" -->
            <router-link to="/data_calculate" >
                <li :class="{ active: active == MENU_ACTIVE.DATA_CALCULATE }" >
                    <img src="../assets/menu/zhishibiaoqianfuzhu.svg" />
                    <span style="text-align: center;">知识标签<br>辅助</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'D01A03')" -->
            <router-link to="/task_distribute" >
                <li :class="{ active: active == MENU_ACTIVE.Task_Distribute }" >
                    <img src="../assets/menu/renwufenfa.svg" />
                    任务分发
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'D01A04')" -->
            <router-link to="/task_claim" >
                <li :class="{ active: active == MENU_ACTIVE.Task_Claim }" >
                    <img src="../assets/menu/renwurenling.svg" />
                    任务认领
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'D01A05')" -->
            <router-link to="/task_data_verify" >
                <li :class="{ active: active == MENU_ACTIVE.Data_Verify }"  >
                    <img src="../assets/menu/shujushenhe.svg" />
                    数据审核
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'D01A06')" -->
            <router-link to="/processing_task" >
                <li :class="{ active: active == MENU_ACTIVE.Data_Manage }" >
                    <img src="../assets/menu/renwuguanli.svg" />
                    任务管理
                </li>
            </router-link>
            <!--<router-link to="/data_get">
                <li :class="{ active: active == MENU_ACTIVE.DATA_GET }">
                    <img src="/static/menu/dataget.svg" />
                    数据获取
                </li>
            </router-link>
            <router-link to="/online_analyse">
                <li :class="{ active: active == MENU_ACTIVE.ONLINE_ANALYSE }">
                    <img src="/static/menu/onlineanalysis.svg" />
                    在线分析
                </li>
            </router-link>
            <router-link to="/">
                <li :class="{ active: active == MENU_ACTIVE.INTELLIGENCE_ANALYSE }">
                    <img src="../assets/menu/zhinengfenxi.png" />
                    智能分析
                </li>
            </router-link>-->
        </template>
      <!--   数据使用   -->
      <template v-if="header == HEADER_ACTIVE.DATA_MALL">
          <!-- v-show="functionInfoList.some(item => item == 'C01A02')" -->
        <router-link to="/my_data_registration" >
          <li :class="{ active: active == MENU_ACTIVE.DATA_Registration }" >
            <img src="/static/menu/shujujiazai.svg" />
            <span style="text-align: center;">数据<br>登记发现</span>
          </li>
        </router-link>
        <!-- v-show="functionInfoList.some(item => item == 'E01A01')" -->
        <router-link to="/data_mall" >
          <li :class="{ active: active == MENU_ACTIVE.data_product }"  >
              <img src="../assets/menu/shujuchanpin.svg" />
              <span style="text-align: center;">数据<br>产品目录</span>
          </li>
        </router-link>
        <!-- v-show="functionInfoList.some(item => item == 'E01A03')" -->
        <router-link to="/data_get" >
          <li :class="{ active: active == MENU_ACTIVE.data_content }">
            <img src="../assets/menu/myshujumoxing.svg" />
            <span style="text-align: center;">数据<br>内容发现</span>
          </li>
        </router-link>
        <!-- v-show="functionInfoList.some(item => item == 'E01A04')" -->
        <!-- <router-link to="/data_statistics" >
          <li :class="{ active: active == MENU_ACTIVE.data_statistics }"  >
            <img src="../assets/menu/shujutongji.svg" />
            <span style="text-align: center;">数据<br>态势统计</span>
          </li>
        </router-link> -->
      </template>
        <!--个人工作台-->
        <template v-if="header == HEADER_ACTIVE.MY_DATA">
          <!-- v-show="functionInfoList.some(item => item == 'F01A01')" -->
            <router-link to="/my_data_model" >
                <li :class="{ active: active == MENU_ACTIVE.My_Data_Model }" >
                    <img src="../assets/menu/myshujumoxing.svg" />
                    <span style="text-align: center;">我的<br>数据模型</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'F01A02')" -->
            <router-link to="/my_process_task" >
                <li :class="{ active: active == MENU_ACTIVE.MyProcessTask }" >
                    <img src="../assets/menu/renwurenling.svg" />
                    <span style="text-align: center;">我的<br>数据加工</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'F01A03')" -->
            <router-link to="/my_data_task" >
                <li :class="{ active: active == MENU_ACTIVE.My_Data_Task }" >
                    <img src="../assets/menu/myshujujiagong.svg" />
                    <span style="text-align: center;">我的<br>智能计算</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'F01A04')" -->
            <router-link to="/my_data_resource" >
                <li :class="{ active: active == MENU_ACTIVE.My_Data_Resource }" >
                    <img src="../assets/menu/myshujuziyuan.svg" />
                    <span style="text-align: center;">我的<br>数据获取</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'F01A05')" -->
            <router-link to="/my_data_algorithm" >
                <li :class="{ active: active == MENU_ACTIVE.My_Data_Algorithm }" >
                    <img src="../assets/menu/myshujusuanfa.svg" />
                    <span style="text-align: center;">我的<br>数据算法</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'F01A06')" -->
            <router-link to="/my_interaction" >
                <li :class="{ active: active == MENU_ACTIVE.My_interaction }" >
                    <img src="../assets/menu/hudongguanli.svg" />
                    <span style="text-align: center;">我的<br>互动管理</span>
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'F01A07')" -->
            <router-link to="/my_grouping" >
                <li :class="{ active: active == MENU_ACTIVE.My_grouping }" >
                    <img src="../assets/menu/wodefenzu.svg" />
                    <span style="text-align: center;">我的<br>分组管理</span>
                </li>
            </router-link>
             <router-link to="/data_view_algorithm" >
                <li :class="{ active: active == MENU_ACTIVE.Data_View_Algorithm }">
                    <img src="../assets/menu/shujusuanfa.svg" />
                    <span style="text-align: center;">数据算法<br>管理</span>
                </li>
            </router-link>
        </template>
        <!--综合管理-->
        <template v-if="header == HEADER_ACTIVE.USER_MANAGER">
          <!-- v-show="functionInfoList.some(item => item == 'G01A01')" -->
            <router-link to="/user_power" >
                <li :class="{ active: active == MENU_ACTIVE.User_Power }" >
                    <img src="../assets/menu/yonghuguanli.svg" />
                    用户管理
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'G01A02')" -->
            <router-link to="/data_administrations" >
                <li :class="{ active: active == MENU_ACTIVE.Data_Administrations}" >
                    <img src="../assets/menu/shujuyuanguanli.svg" />
                    <!-- 数据源管理 -->
                    模型存储<br/>地址管理
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'G01A03')" -->
            <router-link to="/permissionManagement" >
                <li :class="{ active: active == MENU_ACTIVE.Permission_Management }" >
                    <img src="../assets/menu/yonghu_quanxianguanli.svg" />
                    权限管理
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'G01A04')" -->
            <router-link to="/auditing" >
                <li :class="{ active: active == MENU_ACTIVE.User_Audit }" >
                    <img src="../assets/menu/yonghu_anquanshenji.svg" />
                    安全审计
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'G01A05')" -->
            <router-link to="/workloadStatistics" >
                <li :class="{ active: active == MENU_ACTIVE.User_Stat }" >
                    <img src="../assets/menu/yonghu_stat.svg" />
                    工作量统计
                </li>
            </router-link>
            <!-- v-show="functionInfoList.some(item => item == 'G01A06')" -->
          <router-link to="/AssetsAudit" >
                <li :class="{ active: active == MENU_ACTIVE.Assets_Audit }" >
                    <img src="../assets/menu/zichanshenhe.svg" />
                    产品审核
                </li>
            </router-link>
        </template>
      <!--   我的信息   -->
      <template v-if="header == HEADER_ACTIVE.MY_INFORMATION">
          <!-- v-show="functionInfoList.some(item => item == 'H01')" -->
        <router-link to="/myInformation" >
          <li :class="{ active: active == MENU_ACTIVE.MY_INFORMATION }">
            <img src="../assets/menu/gerenxinxi.svg" />
            个人信息
          </li>
        </router-link>
        <!-- v-show="functionInfoList.some(item => item == 'H01')" -->
        <router-link to="/changePassword" >
          <li :class="{ active: active == MENU_ACTIVE.Change_Password }">
            <img src="../assets/menu/xiugaimima.svg" />
            修改密码
          </li>
        </router-link>
      </template>
    </ul>
</template>

<script>
import {queryFunctionByUserId} from "@/service/authorityManagement";
import {checkUser, getFunctionInfo} from "@/util/login";

export default {
    name: 'Menu',
    data () {
        return {
          userInfo: {},
          functionInfoList:[],
        }
    },
    props: {
        active: String,
        header: String
    },
  created() {
    this.userInfo = checkUser() || {};
    this.functionInfoList = this.userInfo?.functionInfo || [];
  },
  mounted() {
    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
@import '@/style/var.scss';


.Menu__warp_nstl {
    //width: 75px;
    width: 85px;
    //background: $--color-primary-light-2;
    //background: #5e9cca;
    //background: #5a84bd;
    background: #5e9cca;
    border-radius: 0px 0px 0px 0px;
    position: fixed;
    left: 0;
    z-index: 100;
    height: 100%;
//     position: absolute;
//     top: 68px;
//     left: 0px;
    z-index: 100;

    li {
        width: 100%;
        height: 80px;
        display: flex;
        flex-direction: column;
        font-size: 12px;
        color: #f6f6f6;
        gap: 6px;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
            width: 30px;
            height: 30px;
        }

        &:hover {
            //background: #5177aa;
            //background: #206498;
            //background: rgba(0, 0, 0, 0.3);
            background: #2771a8;
            color: #fff;
        }
    }

    .active {
        /*background: $--color-primary;*/
        //background: #5177aa;
        //background: #206498;
        //background: rgba(0, 0, 0, 0.3);
        background: #2771a8;
        font-weight: 600;
        color: #fff;
    }
}
</style>